import { StateAdvisorReducer } from '@interhyp/shared-page-modules';
import { createStore } from 'redux-dynamic-modules';
import { IModule } from 'redux-dynamic-modules-core/src/Contracts';
import thunk from 'redux-thunk';

import { getConfigurationModule } from './Configuration/module';
import { getIntentsModule } from './Intents/module';
import { getMandantConfigModule } from './MandantConfig/module';
import { getProfileModule } from './Profile/module';

const modules: IModule<any>[] = [
  getConfigurationModule(),
  /* getSessionModule(),*/
  getMandantConfigModule(),
  getProfileModule(),
  getIntentsModule(),
  /*    communicationModule,*/
  /*    getIntentDataModule(),
  getEstateModule(),
  getApplicantModule(),*/
  /* getTokenModule(),*/
  {
    id: 'PersonalAdvisor',
    reducerMap: {
      PersonalAdvisor: StateAdvisorReducer,
    },
    initialActions: [],
    finalActions: [],
  },
  /*
  {
    id: 'appointments',
    reducerMap: {
      appointments: AppointmentsReducer,
    },
    initialActions: [],
    finalActions: [],
  },*/
];

export const store = createStore(
  {
    extensions: [{ middleware: [thunk.withExtraArgument({})] }],
  },
  modules as any, // type checking with function overloading not working correctly here
);
